import getMissedBreaks from '@sdk/automatedBreaks/helpers/getMissedBreaks';
import getBreaksSummary from '@sdk/automatedBreaks/helpers/getBreaksSummary';
import { TimesheetEntry } from '@sdk/timesheets/types/TimesheetEntry';
import { BreakAttestation } from '@sdk/automatedBreaks/types/Attestation';

import {
  takenBreaksSummary,
  getSummariesTextToDisplay,
} from '@web/timeClock/modals/rows/ActualRow/clockInSummary.utils';
import { getRelevantTimesheetEntries } from '@web/timeClock/modals/rows/ActualRow/automatedBreaksSummary.utils';

type Props = {
  allTimesheetEntries: TimesheetEntry[];
  breakAttestations: BreakAttestation[];
  clockInTime: {
    clockIn: Date;
    clockInLocal: Date;
    clockOutLocal: Date;
    isInProgress: boolean;
  };
};

export const useAutomatedBreaksSummary = ({
  allTimesheetEntries,
  clockInTime,
  breakAttestations,
}: Props) => {
  const { clockIn, clockInLocal, clockOutLocal, isInProgress } = clockInTime;
  const { breakRecords } = getBreaksSummary(
    allTimesheetEntries,
    clockInLocal,
    clockOutLocal,
    breakAttestations
  );
  const timesheetEntries = getRelevantTimesheetEntries(allTimesheetEntries, clockIn);
  // Don't show missed breaks for in progress shift.
  const missedBreaks = isInProgress
    ? { meal: [], rest: [] }
    : getMissedBreaks(timesheetEntries, clockOutLocal, breakAttestations);
  const summary = takenBreaksSummary(breakRecords, breakAttestations);

  return getSummariesTextToDisplay(summary, {
    meal: missedBreaks.meal?.length || 0,
    rest: missedBreaks.rest?.length || 0,
  });
};
